import { Card, Field } from "@/components/kit";
import { Stepper } from "@/components/Stepper";
import { RISER } from "@/lib/measure";
import { METRIC } from "@/lib/units";
import { StickPhoto } from "@/components/StickPhoto";
import { ManwayPhoto } from "@/components/measure/ManwayPhoto";

export const MeasureInputs = ({ m, set, t }) => (
  <Card testID="measure-inputs">
    <Field label={METRIC ? t("Stick reading at the bottom (cm)") : t("Stick reading at the bottom (inches)")}>
      <Stepper testID="measure-bottom" unit="in" decimal step={0.5} max={200} value={m.bottomIn} onValue={(v) => set({ bottomIn: v })} />
      <StickPhoto testid="measure-bottom" mode="bottom" max={200} onValue={(v) => set({ bottomIn: v })} />
    </Field>
    <div className="card-sub">{t("Slide the stick down the fill pipe until it hits the tank bottom. Read the stick at the top of the fill pipe.")}</div>
    <Field label={METRIC ? t("Fill pipe above the tank (cm)") : t("Fill pipe above the tank (inches)")}>
      <Stepper testID="measure-riser" unit="in" decimal step={1} min={RISER.min} max={RISER.max} value={m.riserIn} onValue={(v) => set({ riserIn: v })} />
    </Field>
    <div className="card-sub">{t("From the fill cap down to the top of the tank. Usually 12–36 in; 24 in if you don't know.")}</div>
    <Field label={METRIC ? t("Distance between the end manway lids (m, optional)") : t("Distance between the end manway lids (feet, optional)")}>
      <Stepper testID="measure-spacing" unit="ft" decimal step={0.5} max={90} value={m.spacingFt} onValue={(v) => set({ spacingFt: v })} />
    </Field>
    <ManwayPhoto onSpacing={(v) => set({ spacingFt: v })} t={t} />
    <div className="card-sub">{t("Tape or pace it across the lot. One long step is about 2.5 ft. Leave 0 if you can't tell.")}</div>
    <div className="seg" data-testid="measure-ends">
      <button type="button" className={m.ends === "dome" ? "seg-on" : ""} onClick={() => set({ ends: "dome" })} data-testid="measure-ends-dome">{t("Fiberglass (rounded ends)")}</button>
      <button type="button" className={m.ends === "flat" ? "seg-on" : ""} onClick={() => set({ ends: "flat" })} data-testid="measure-ends-flat">{t("Steel (flat ends)")}</button>
    </div>
  </Card>
);
